import { Endpoints } from 'utils/paths';
import { clientApi } from '../api';

export const getErrorPageContent = async (): Promise<ErrorPageContent> => {
  const response = await clientApi.get<ErrorPageContent>(
    Endpoints.ERROR_PAGE_CONTENT,
  );

  return response.data;
};

export const getAppLayoutContent = async (): Promise<AppLayoutContent> => {
  const response = await clientApi.get<AppLayoutContent>(
    Endpoints.APP_LAYOUT_CONTENT,
  );

  return response.data;
};
